import React from 'react'

const ChatModal = () => {
  return (
    <div className="modal fade select-worker-modal-sec" id="chatModal"  tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header d-flex align-items-center justify-content-between gap-2">
                    <h1>Select Worker</h1>
                    <button type="button" className="btn-close"  data-bs-dismiss="modal"  aria-label="Close" >
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#F1F1F1"/><path d="M22.3007 9.70997C21.9107 9.31997 21.2807 9.31997 20.8907 9.70997L16.0007 14.59L11.1107 9.69997C10.7207 9.30997 10.0907 9.30997 9.7007 9.69997C9.3107 10.09 9.3107 10.72 9.7007 11.11L14.5907 16L9.7007 20.89C9.3107 21.28 9.3107 21.91 9.7007 22.3C10.0907 22.69 10.7207 22.69 11.1107 22.3L16.0007 17.41L20.8907 22.3C21.2807 22.69 21.9107 22.69 22.3007 22.3C22.6907 21.91 22.6907 21.28 22.3007 20.89L17.4107 16L22.3007 11.11C22.6807 10.73 22.6807 10.09 22.3007 9.70997Z" fill="#301E39"/></svg>
                    </button>
                </div>
                <div className="modal-body">

                </div>
            </div>
        </div>
    </div>
  )
}

export default ChatModal
